import React from 'react'
import { useTranslation } from 'react-i18next'

import {
  IconCheckCircle,
  IconWarningCircle,
  IconCloseCircle,
} from 'components/Icons'
import { WARRANTY } from 'helpers/constants'
import { getWarrantyType } from 'helpers/common'
import { WARRANTY_TYPE } from 'types'

export interface ProductWarrantyProps {
  isProduct?: boolean
  startWarranty?: string | null
  endWarranty?: string | null
  warrantyType?: WARRANTY_TYPE | string
}

function TicketProductWarranty(props: ProductWarrantyProps): JSX.Element {
  const { t } = useTranslation('ticket')

  const {
    startWarranty,
    endWarranty,
    warrantyType = WARRANTY.NO_WARRANTY,
    isProduct,
  } = props

  const base = 'f-ticket-product-info'

  const warrantyTypeValue = getWarrantyType(
    startWarranty,
    endWarranty,
    warrantyType,
  )

  if (
    isProduct &&
    warrantyType.toLocaleLowerCase() === WARRANTY_TYPE.LIFETIME
  ) {
    return (
      <div className={`${base}__row`}>
        <IconCheckCircle className={`${base}__warranty--active`} />
        <span className={`${base}__warranty ${base}__warranty--active`}>
          {t('product.lifetime.warranty')}
        </span>
      </div>
    )
  }

  switch (warrantyTypeValue) {
    case WARRANTY.ACTIVE:
      return (
        <div className={`${base}__row`}>
          <IconCheckCircle className={`${base}__warranty--active`} />
          <span className={`${base}__warranty ${base}__warranty--active`}>
            {isProduct ? t('product.active.warranty') : t('active.warranty')}
          </span>
        </div>
      )

    case WARRANTY.EXPIRES:
      return (
        <div className={`${base}__row`}>
          <IconWarningCircle className={`${base}__warranty--expires`} />
          <span className={`${base}__warranty ${base}__warranty--expires`}>
            {t('expires.warranty')}
          </span>
        </div>
      )

    case WARRANTY.NO_WARRANTY:
    default:
      return (
        <div className={`${base}__row`}>
          <IconCloseCircle className={`${base}__no-warranty`} />
          <span className={`${base}__warranty ${base}__no-warranty`}>
            {t('no.warranty')}
          </span>
        </div>
      )
  }
}

export default TicketProductWarranty
